import { render, staticRenderFns } from "./VideoCardThumbnail.vue?vue&type=template&id=d0d8d2d0&"
import script from "./VideoCardThumbnail.vue?vue&type=script&lang=ts&"
export * from "./VideoCardThumbnail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports